import sdkSessionUtil from 'bam-browser-sdk-sdkSession-util'; //eslint-disable-line import/no-extraneous-dependencies

const localStorageKey = '__btm__web_userLocation';

function isExpired(dateString) {
    const currentDate = new Date();
    const expirationDate = Date.parse(dateString);
    return currentDate > expirationDate;
}

export default function () {
    return new Promise((resolve, reject) => {
        try {
            const localStorageItem = JSON.parse(localStorage.getItem(localStorageKey));
            if (localStorageItem && !isExpired(localStorageItem.expires)) {
                resolve(localStorageItem.location);
            } else {
                sdkSessionUtil.getSdkSession()
                    .then((sdkSession) => {
                        return sdkSession.getSessionInfo();
                    })
                    .then((sessionInfo) => {
                        return sessionInfo.location;
                    })
                    .then((location) => {
                        const expires = new Date();
                        expires.setHours(expires.getHours() + 4);
                        const data = {
                            expires,
                            location
                        };
                        localStorage.setItem(localStorageKey, JSON.stringify(data));
                        resolve(location);
                    })
                    .catch(reject);
            }
        } catch (error) {
            console.error(error);
            reject('Invalid JSON');
        }
    });
}
